import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  DOWNLOAD_AUDIENCE_BUILDER,
  DOWNLOAD_AUDIENCE_BUILDER_SUCCESS,
} from '../../constants';

import saveAs from 'file-saver';

import { toast } from 'react-toastify';

let toastId = 'downloadAudienceBuilder';

const downloadAudienceBuilder = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_AUDIENCE_BUILDER),
    switchMap(action => {

      toastId = toast('Downloading Audience...', {
        id: toastId,
        autoClose: false,
        position: 'top-center',
        style: { textAlign: 'center' },
        closeButton: false, // Remove the closeButton
      });

      return ajax({
        url: `${state$.value.auth.audienceBuilderServer}/audiences/${
          action.payload.audienceId
        }/download?filename=${action.payload.filename}&identifierName=${
          action.payload.identifierName
        }&os=${action.payload.os}&excludeAdTrackingDisabled=${
          action.payload.excludeAdTrackingDisabled
        }`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        responseType: 'text',
        crossDomain: true,
        method: 'GET',
      }).pipe(
        map(response => {

          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: "Download Completed",
            autoClose: 3000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(237, 247, 237)', color: 'rgb(30, 70, 32)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });

          const blob = new Blob([`${response.response}`], { type: 'text/csv' });
          const fileName = `LANDMARKSID_${action.payload.fileName}_${
            action.payload.identifierName
          }_${action.payload.os}`;

          saveAs(blob, fileName);

          return {
            type: DOWNLOAD_AUDIENCE_BUILDER_SUCCESS,
          };
        }),
        catchError(error => {

          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: "Download Failed",
            autoClose: 6000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(253, 236, 234)', color: 'rgb(97, 26, 21)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });

        })
      );
    })
  );

export default downloadAudienceBuilder;
